import { render } from "./builder.vue?vue&type=template&id=7f490efe"
import script from "./builder.vue?vue&type=script&lang=js"
export * from "./builder.vue?vue&type=script&lang=js"

import "./builder.vue?vue&type=style&index=0&id=7f490efe&lang=css"

import exportComponent from "/home/aptask/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__